<p-panel styleClass="no-padding-panel panel-shadow">
  <p-header>
    <div class="panel-header">Additional Costs</div>
  </p-header>
  <div *ngIf="additionalCosts.length > 0">
    <p-table
      [value]="additionalCosts"
      [responsive]="true"
      [rowHover]="true"
      tableStyleClass="table-no-top-corners"
      styleClass="no-border-table table-no-bottom-corners"
      [(selection)]="selectedAdditionalCharge"
      selectionMode="single"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Vehicle Reg.</th>
          <th>Charge Type</th>
          <th>Amount</th>
          <th>Description</th>
          <th>Photo</th>
          <th>Additional Cost Logged</th>
          <th>Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-charge>
        <ng-container *ngIf="asAdditionalCost(charge) as item">
          <tr [pSelectableRow]="item">
            <td>{{ item.task?.vehicle?.registrationNumber }}</td>
            <td>{{ item.additionalChargeType.chargeType }}</td>
            <td class="text-center">
              <b>{{ item.chargeAmount | currency : 'GBP' : 'symbol' : '1.2-2' }} </b>
            </td>
            <td style="overflow-x: hidden; white-space: wrap">
              <span>{{ item.otherCharge }}</span>
            </td>
            <td class="text-center">
              <a
                *ngIf="item.photographPublicUrl"
                style="cursor: pointer"
                (click)="openPhoto(item.photographPublicUrl, item.photographLocation)"
              >
                <i class="material-icons">photo_camera</i>
                <div>View</div>
              </a>
            </td>
            <td class="text-center">
              <div>{{ item.createdOn | datex : 'ddd Do MMM' }}</div>
              <div>{{ item.createdOn | datex : 'HH:mm' }}</div>
            </td>
            <td style="text-align: center">
              <div class="text-center approved-declined" [ngClass]="getApprovalStatusClass(item)">
                {{ getStatusName(item.additionalChargeStatus?.name) }}
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>

  <p-footer class="no-rounded-top-border">
    <div style="">
      <div style="text-align: right">
        <button
          type="button"
          pButton
          icon="fa ui-icon-add"
          label="Add Additional Cost"
          class="ui-button btn-mobile-block mb-2"
          (click)="addAdditionalCharge()"
          [disabled]="!canAddExpense"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-edit"
          label="Edit"
          class="ui-button btn-mobile-block mb-2"
          (click)="editAdditionalCharge(selectedAdditionalCharge.id)"
          [disabled]="editDisabled"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-trash"
          label="Delete"
          [disabled]="deleteDisabled"
          class="ui-button red-btn btn-mobile-block mb-2"
          (click)="deleteAdditionalCharge(selectedAdditionalCharge)"
        ></button>
      </div>
    </div>
  </p-footer>
</p-panel>

<ngx-gallery
  *ngIf="expenseImages.length > 0"
  [options]="expenseGalleryOptions"
  [images]="expenseImages"
  (previewClose)="onExpenseImagePreviewClose()"
></ngx-gallery>

<p-dialog
  [header]="(editingAdditionalCharge ? 'Edit' : 'Add') + ' Additional Cost'"
  [(visible)]="showUpsertDialog"
  [responsive]="true"
  [modal]="false"
  [style]="{ width: '500px', height: '600px;' }"
>
  <div class="ui-g" style="position: relative; min-height: 280px; overflow-y: auto">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Charge Type</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="chargeTypeOptions"
          name="additionalChargeTypes"
          [style]="{ width: '100%' }"
          [(ngModel)]="additionalChargeToUpsert.additionalChargeTypeId"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Task No</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="taskOptions"
          name="taskNumbers"
          [style]="{ width: '100%' }"
          [(ngModel)]="additionalChargeToUpsert.taskId"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Amount (£)</label>
      </div>
      <div class="ui-grid-col-8">
        <input
          [(ngModel)]="additionalChargeToUpsert.chargeAmount"
          [style]="{ width: '100%' }"
          pInputText
          maxlength="10"
          (keydown)="inputHelper.allowNumberInputKey($event)"
          (keyup)="inputHelper.fixDigitsAndMax($event.target, 1000000)"
          [disabled]="isAddAdditionalCostReadOnly()"
        />
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Description</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea
          name="otherCharge"
          maxlength="255"
          style="width: 100%; height: 50px"
          [(ngModel)]="additionalChargeToUpsert.otherCharge"
          id="otherCharge"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></textarea>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Photo</label>
      </div>
      <div class="ui-grid-col-8">
        <p-fileUpload
          name="files"
          url="/api/filestorage/fileuploading"
          (onBeforeUpload)="onBeforeUpload($event)"
          (onSelect)="onSelect($event)"
          (onError)="onError($event)"
          (onUpload)="onAdditionalCostFileUpload($event)"
          withCredentials="true"
          [maxFileSize]="83886080"
          [accept]="'application/pdf,image/*,.heic'"
          auto="true"
          chooseLabel="Upload Photo"
          mode="basic"
          [disabled]="isAddAdditionalCostReadOnly()"
        ></p-fileUpload>
        <div style="height: 25px">
          <a
            *ngIf="additionalChargeToUpsert.photographLocation"
            style="cursor: pointer"
            (click)="openPhotoPresigned(additionalChargeToUpsert.photographLocation)"
          >
            <i class="material-icons">photo_camera</i>
          </a>
        </div>
      </div>
    </div>
  </div>
  <p-footer class="no-rounded-top-border rounded-bottom-border">
    <div style="text-align: right">
      <button
        type="button"
        (click)="closeAdditionalChargeUpsertDialog()"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        [disabled]="saveAdditionalChargeDisabled()"
        (click)="saveAdditionalCharge()"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-confirmDialog #cd key="delete-charge" [closable]="false" [style]="{ width: '425px' }">
  <p-footer class="rounded-bottom-border">
    <button
      type="button"
      pButton
      class="ui-button ui-button-tertiary"
      label="No"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      pButton
      class="ui-button ui-button-danger"
      label="Yes - Delete"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
